// 因為 next.config 也要用(CJS require、build 環境是 Node 16),所以只能用 es5 寫法,不能用 export。
// 這份名單同時是 next.config images.domains(optimizer 白名單)與 common/Image 判斷「走 next/image 還是原生 img」的依據。
// source.tutorabc.com / s3.tutorabcshop.com 從 pre、prod 機器 server-side 抓不到(/_next/image 一律 500),
// 移出名單讓它們走原生 img 由瀏覽器直接載入(v2 預設頭像 https://source.tutorabc.com/shop/head.png 破圖的根因)。
const imageDomain = ['s3.tutorabc.com', 'down-tw.img.susercontent.com', 'www.tutorabcshop.com']

module.exports = { imageDomain }
